// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crosswind-landing-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crosswind-landing-technique/crosswind-landing-technique.js';

mount([g0]);
